module.exports = __webpack_public_path__ + "static/media/img10.2f6d0dbf.jpg";